// Ticking countdown of the designs (the countdown strip of call_to_action, the spotlight hero). The view prints
// event/partials/countdown.php: `[data-rem-countdown="<unix seconds>"]` with one `[data-rem-countdown-unit]` per
// unit (days, hours, minutes, seconds) already filled on the server, so the numbers are right without the script.
// The script only keeps them ticking; once the target has passed the countdown is hidden.

// Whole days, hours, minutes and seconds from now until the target; all zero once it has passed.
export const remaining = (targetMs, nowMs) => {
    const total = Math.max(0, Math.floor((targetMs - nowMs) / 1000));

    return {
        days: Math.floor(total / 86400),
        hours: Math.floor(total / 3600) % 24,
        minutes: Math.floor(total / 60) % 60,
        seconds: total % 60,
        total,
    };
};

const pad = (value, unit) => (unit === 'days' ? String(value) : String(value).padStart(2, '0'));

const tick = (countdown) => {
    const left = remaining(Number(countdown.dataset.remCountdown) * 1000, Date.now());
    countdown.querySelectorAll('[data-rem-countdown-unit]').forEach((node) => {
        const unit = node.dataset.remCountdownUnit;
        node.textContent = pad(left[unit] ?? 0, unit);
    });

    return left.total > 0;
};

export const initCountdowns = (root) => {
    root.querySelectorAll('[data-rem-countdown]').forEach((countdown) => {
        if (!tick(countdown)) {
            countdown.hidden = true;
            return;
        }
        const timer = window.setInterval(() => {
            if (!tick(countdown)) {
                window.clearInterval(timer);
                countdown.hidden = true;
            }
        }, 1000);
    });
};
